export default __webpack_public_path__ + "static/media/coinbase.58bab946.svg";